import React from "react";
import Button from "../../common/button/button.jsx";
import { SemiCircleProgressBar } from "../../common/semiCircleProgressBar/semiCircleProgressBar.jsx";
import { adicionarPontosMilhar } from "../../utils/adicionarPontosMilhar.js";

export function EnergiaCard({
    titulo,
    energia,
    energiaMax,
    percentual,
    desempenho,
    unidade,
    tipoGrafico,
    item,
    setModoTela,
    bgButton,
    getCorDesempenho
}) {
    return (
        <div style={{ width: "30%", display: "flex", justifyContent: "center" }}>
            <Button
                style={{
                    width: "100%",
                    height: 150,
                    padding: 0,
                    margin: "5px 0px",
                    background: "linear-gradient(225deg, rgb(255 255 255) 0%, rgb(145 234 255) 100%)",
                    borderRadius: "0.6rem",
                }}
                title={`Ver o gráfico\n${energia} de ${energiaMax} (${percentual}%)`}
                text={
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", color: "#000" }}>
                        <b
                        style={{
                            marginBlock: 10,
                            textAlign: "center",
                            fontSize: "clamp(0.8rem, 2vw, 1rem)", //controla o tamanho da fonte entre 0.8rem e 1rem, dependendo do tamanho da tela
                            lineHeight: 1.1,
                        }}
                        >
                        {titulo}
                        </b>
                        <SemiCircleProgressBar
                            stroke="#CCC"
                            width={95}
                            height={100}
                            progress={desempenho}
                            classColor={"info"}
                            minMaxMedium={[81, 93]}
                        >
                            <div style={{ fontSize: "0.8rem" }}>
                                {adicionarPontosMilhar(energia, 1)}
                            </div>

                            <div style={{ fontSize: "0.8rem" }}>
                                {unidade}
                            </div>

                            <div style={{ fontSize: "0.7rem" }}>
                                <i className="fas fa-sun mr-1" /> {percentual}%
                            </div>

                            <div style={{ fontSize: "0.7rem" }}>
                                <i className="fas fa-tachometer-alt mr-1" />{" "}
                                {(Number(desempenho || 0)).toFixed(1).replace(".", ",")}%
                            </div>
                        </SemiCircleProgressBar>
                    </div>
                }
                type={"info"}
                event={() => setModoTela(tipoGrafico, item)}
            />
        </div>
    );
}